import Header from './components/Header';
import Hero from './components/Hero';
import PlanSection from './components/PlanSection';
import ReasonSection from './components/ReasonSection';
import TroubleSection from './components/TroubleSection';
import Features from './components/Features';
import WhatIs1Day from './components/WhatIs1Day';
import OurClinic from './components/OurClinic';
import BeforeAfter from './components/BeforeAfter';
import CTA from './components/CTA';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import FloatingCallButton from '../../components/feature/FloatingCallButton';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <PlanSection />
      <ReasonSection />
      <TroubleSection />
      <CTA />
      <WhatIs1Day />
      <Features />
      <CTA />
      <OurClinic />
      <BeforeAfter />
      <FAQ />
      <Footer />
      <FloatingCallButton />
    </div>
  );
}
